import LeaderboardPopup from './LeaderboardPopup';

export default LeaderboardPopup;
